import React from "react";
import { useParams, Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import { SERVICES } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import { CheckCircle2, ArrowRight, ArrowLeft } from "lucide-react";
import CTASection from "../components/CTASection";

export default function ServiceDetail() {
  const { services = SERVICES } = useContent();
  const { slug } = useParams();
  const service = services.find((s) => s.slug === slug) || services[0];

  const bullets = [
    "İşletme ve sektör analizi ile en uygun destek programının belirlenmesi",
    "Başvuru evraklarının hazırlanması ve eksiksiz sunumu",
    "Resmi kurumlarla süreç yönetimi ve takip",
    "Raporlama, izleme ve sonuçlandırma",
    "Stratejik planlama ve uzun vadeli destek"
  ];

  return (
    <>
      <PageHero kicker="HİZMET DETAYI" title={service.title} subtitle={service.short} />
      <section className="py-20 lg:py-28 bg-[#0a0a0a]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8 space-y-6 text-[#a89a85] leading-relaxed">
            <p>
              {service.title} sürecinde AR Danışmanlık ekibi, işletmenizin ihtiyaçlarını analiz eder; size özel bir yol haritası çıkarır ve başvurudan sonuca kadar tüm süreci yönetir. Amacımız; yatırımlarınızın gerçek potansiyeline ulaşmasını sağlamaktır.
            </p>
            <p>
              Uzman kadromuz; mevzuat, mali planlama ve proje yönetimi disiplinlerini bir araya getirir. Her adımda şeffaf raporlama, veri odaklı kararlar ve işlevsel çözümler sunarız.
            </p>
            <h3 className="font-serif-display text-[#f5ede1] text-3xl pt-6">Süreç İçeriği</h3>
            <ul className="space-y-4">
              {bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#B87333] mt-0.5 flex-shrink-0" strokeWidth={1.5} />
                  <span className="text-[#f5ede1]/90">{b}</span>
                </li>
              ))}
            </ul>
            <div className="pt-10 flex flex-wrap gap-4">
              <Link to="/iletisim" className="inline-flex items-center gap-3 px-8 py-4 bg-[#B87333] text-[#0a0a0a] text-[11px] tracking-[0.3em] font-semibold hover:bg-[#D4A574] transition-colors">
                GÖRÜŞME TALEBİ <ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/hizmetlerimiz" className="inline-flex items-center gap-3 px-8 py-4 border border-[#B87333]/40 text-[#f5ede1] text-[11px] tracking-[0.3em] font-semibold hover:border-[#B87333] hover:text-[#B87333] transition-colors">
                <ArrowLeft className="w-4 h-4" /> TÜM HİZMETLER
              </Link>
            </div>
          </div>
          <aside className="lg:col-span-4">
            <div className="border border-[#B87333]/20 bg-[#0d0b09] p-8 sticky top-28">
              <h4 className="text-[11px] tracking-[0.3em] text-[#B87333] mb-5">DİĞER HİZMETLER</h4>
              <ul className="space-y-3">
                {services.filter((s) => s.slug !== service.slug).slice(0, 6).map((s) => (
                  <li key={s.slug}>
                    <Link
                      to={`/hizmet/${s.slug}`}
                      className="flex items-start gap-2 text-sm text-[#f5ede1] hover:text-[#B87333] transition-colors"
                    >
                      <ArrowRight className="w-3 h-3 mt-1 text-[#B87333]" />
                      <span>{s.title}</span>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </aside>
        </div>
      </section>
      <CTASection />
    </>
  );
}
